module.exports = __webpack_public_path__ + "static/ilham-cf4780ddc690707daafe072ec795d2eb.jpg";